import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import SkipToContent from './components/SkipToContent'
import ScrollToTop from './components/ScrollToTop'
import CookieBanner from './components/CookieBanner'
import { useGoogleAnalytics } from './hooks/useGoogleAnalytics'
import Home from './pages/Home'
import SolarPanels from './pages/SolarPanels'
import HeatPumps from './pages/HeatPumps'
// import EVCharging from './pages/EVCharging'
// import AirConditioning from './pages/AirConditioning'
import Contact from './pages/Contact'
import Quote from './pages/QuoteItemPage'
import QuoteOptions from './pages/QuoteOptions'
import AboutUs from './pages/AboutUs'
import WorkWithUs from './pages/WorkWithUs'
import CaseStudies from './pages/CaseStudies'
import Cookies from './pages/Cookies'
import PrivacyPolicy from './pages/PrivacyPolicy'
import CustomerCare from './pages/CustomerCare'
import { UserProvider } from './context/UserContext'

const AppContent = () => {
  useGoogleAnalytics()

  return (
    <div className="min-h-screen bg-white">
      <ScrollToTop />
      <SkipToContent />
      <Header />
      <main id="main-content" role="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/solar-panels" element={<SolarPanels />} />
          <Route path="/heat-pumps" element={<HeatPumps />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/work-with-us" element={<WorkWithUs />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/quote" element={<QuoteOptions />} />
          <Route path="/quote/:service" element={<Quote />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/customer-care" element={<CustomerCare />} />
        </Routes>
      </main>
      <Footer />
      <CookieBanner />
    </div>
  )
}

function App() {
  return (
    <Router>
      <UserProvider>
        <AppContent />
      </UserProvider>
    </Router>
  )
}

export default App